(() => {
  const selectors = {
    featuredProduct: '.js-featured-product',
    featuredProductBottom: '.featured-product__bottom',
    featuredProductSlider: '.featured-product__slider',
  }

  const featuredProductElement = document.querySelector(selectors.featuredProduct);
  if (!featuredProductElement) return;

  const bottomElement = featuredProductElement.querySelector(selectors.featuredProductBottom);
  const sliderElement = featuredProductElement.querySelector(selectors.featuredProductSlider);
  
  if (!bottomElement || !sliderElement) return;

  const isMobile = () => window.innerWidth < 990;
  
  let swiper = null;
  
  const initSwiper = () => {
    if (sliderElement.classList.contains('swiper-initialized')) {
      swiper = sliderElement.swiper;
      return;
    }

    swiper = new Swiper(sliderElement, {
      spaceBetween: 4,
      watchOverflow: true,
      allowTouchMove: true,
      slidesPerView: 1.8,
      breakpoints: {
        990: {
          slidesPerView: 2,
          spaceBetween: 8,
        },
      },
      navigation: {
        nextEl: featuredProductElement.querySelector('.swiper-button-next'),
        prevEl: featuredProductElement.querySelector('.swiper-button-prev'),
      },
      on: {
        init() {
          sliderElement.classList.add('swiper-initialized');
          updateGradientVisibility();
        }
      }
    });
  };

  const updateGradientVisibility = () => {
    if (!swiper) return;
    
    const isAtBeginning = swiper.isBeginning;
    const isAtEnd = swiper.isEnd;
    
    if (isAtBeginning) {
      sliderElement.style.setProperty('--show-left-gradient', '0');
    } else {
      sliderElement.style.setProperty('--show-left-gradient', '1');
    }
    
    if (isAtEnd) {
      sliderElement.style.setProperty('--show-right-gradient', '0');
    } else {
      sliderElement.style.setProperty('--show-right-gradient', '1');
    }
  };

  const initGradients = () => {
    sliderElement.style.setProperty('--show-left-gradient', '0');
    sliderElement.style.setProperty('--show-right-gradient', '1');
  };

  const handleSwiperEvents = () => {
    if (!swiper) return;

    swiper.on('slideChange', updateGradientVisibility);
    swiper.on('slideChangeTransitionEnd', updateGradientVisibility);
    
    updateGradientVisibility();
  };

  initGradients();

  initSwiper();
  
  if (swiper) {
    handleSwiperEvents();
  }
})();
